import { render, staticRenderFns } from "./RiskWarningDialog.vue?vue&type=template&id=3e89e584"
import script from "./RiskWarningDialog.vue?vue&type=script&lang=js"
export * from "./RiskWarningDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports